import { render, staticRenderFns } from "./PersonalizedEdit.vue?vue&type=template&id=25bee91f&scoped=true"
import script from "./PersonalizedEdit.vue?vue&type=script&lang=js"
export * from "./PersonalizedEdit.vue?vue&type=script&lang=js"
import style0 from "./PersonalizedEdit.vue?vue&type=style&index=0&id=25bee91f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bee91f",
  null
  
)

export default component.exports